import React, { useState } from "react";

import { ChallengeDeckCardWrapper } from "./challengeDeckCard.style";
import BookmarkIcon from "../../icons/bookmarkIcon.component";
import useCurrentUser from "../../../hooks/useCurrentUser";
import useAppContext from "../../../hooks/useAppContext";

const ChallengeDeckCard = ({ data }) => {
  const {
    url,
    status,
    smallSnapshotPicUrl,
    companyTeam,
    title,
    statusTitleized,
    pricePot,
    statusDetails,
    addToDojoPath,
    bookmarkStatus,
  } = data;
  const currentUser = useCurrentUser();
  const { axios } = useAppContext();
  const [isBookmarked, setIsBookmarked] = useState(bookmarkStatus);

  const handleBookmark = (e) => {
    e.preventDefault();
    axios.post(addToDojoPath).then(() => {
      setIsBookmarked("draft");
    });
  };

  return (
    <ChallengeDeckCardWrapper className="deck col-12">
      <div className="deck-card d-flex col-12 col-sm-6 col-lg-4 p-2 position-relative">
        <a
          href={url}
          className={`card card-status-${status} rounded hover-box-shadow-dark p-1`}
        >
          <div className="card-body d-flex align-items-center p-0 pb-1 p-lg-2">
            <div className="card-image flex-shrink-0 p-2">
              <img
                src={smallSnapshotPicUrl}
                className="img-fluid rounded-circle"
                alt="Challenge Snapshot Image"
              />
            </div>
            <div className="card-content p-2 pb-3 pt-4 py-lg-3">
              <div className="card-title">
                <span>{companyTeam.displayName}</span>
              </div>
              <div className="card-text">
                <span>{title}</span>
              </div>
            </div>
          </div>
          <div className="card-footer d-flex justify-content-between px-1 py-2 p-md-2 py-lg-3 p-xl-3">
            <div className="card-status flex-fill border-end text-start pe-1">
              <div className="card-footer-label pb-1">Status</div>
              <div className="card-footer-value">
                <span className="badge px-2 px-xl-3 py-1">
                  {statusTitleized}
                </span>
              </div>
            </div>
            <div className="card-timer flex-fill text-center px-1">
              <div className="card-footer-label pb-1">
                {statusDetails?.label}
              </div>
              <div className="card-footer-value">{statusDetails?.value}</div>
            </div>
            <div className="card-reward flex-fill border-start text-end ps-1">
              <div className="card-footer-label pb-1">Total Rewards</div>
              <div className="card-footer-value">
                {pricePot}
                <span className="value-units d-none d-md-inline">USD</span>
              </div>
            </div>
          </div>
        </a>
        {currentUser && (
          <div
            className={`card-bookmark${isBookmarked ? ` bookmark-status-${isBookmarked}` : ""} position-absolute end-0 top-0 m-3`}
          >
            <a href={addToDojoPath} onClick={handleBookmark} className="p-1">
              <BookmarkIcon size={16} state={isBookmarked} />
            </a>
          </div>
        )}
      </div>
    </ChallengeDeckCardWrapper>
  );
};

export default ChallengeDeckCard;
